import React from 'react';
import { BooleanSettings } from 'modules/settingsContainer/common/BooleanSettings';
import { BooleanSettingsControlInterface } from 'modules/settingsContainer/common/BooleanSettings/types';

type AdditionalIndicatorsSettingsProps = Required<BooleanSettingsControlInterface>;

export const AdditionalIndicatorsSettings = ({ value, onChange }: AdditionalIndicatorsSettingsProps) => {
  return <BooleanSettings titleText="Доп. показатель" value={value} onChange={onChange} />;
};
